module.exports = __webpack_public_path__ + "h5/img/mfe_02.d2060703.jpeg";